import React, { useLayoutEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector} from "react-redux";

import Card from "../../UI/Card/Card";
import Section from "../../UI/Others/Section";
import NoteCard from "../../UI/Card/NoteCard";
import Headline from "../../Headline/Headline";

//import EmptyState from "../../UI/State/EmptyState";

import LinkButton from "../../UI/Button/LinkButton";
import ExtLinkButton from "../../UI/Button/ExternalLinkButton";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faDownload, faBook, faCode, faUsers, faComments, faCommentDots, faPhone, faClock, faPaperPlane, faUserCircle, faImages } from "@fortawesome/free-solid-svg-icons";
//import { faNewspaper} from "@fortawesome/free-regular-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

const CSharp = () => {
    const intl = useIntl();
    const version = useSelector((state) => state.documentation.filter);

    const title = intl.messages.csharpTitle;
    const subtitle = intl.messages.csharpMessage;
    const getting_started = "doc/sdk/csharp/core/"+version+"/guides/001_getting_started";

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    function SDKCard(props) {
        return (
            <div className="d-flex col-lg-6">
                <NoteCard title={props.title} isBeta={props.isBeta} icon={props.icon} colorIcon="pink">
                    {props.children}
                </NoteCard>
            </div>
        );
    }

    let cardAction = <div>
        <LinkButton
            className="btn-blue mb-2"
            to={getting_started}
            label={intl.messages.sdkStarted}
            icon={faBook}
        />
        <ExtLinkButton className="btn-green ml-2 mb-2"
            link="https://www.nuget.org/packages/Rainbow.CSharp.SDK/"
            label="SDK"
            icon={faDownload}
        />

        <ExtLinkButton className="btn-orange ml-2 mb-2"
            link="https://github.com/Rainbow-CPaaS/Rainbow-CSharp-SDK-Samples"
            label={intl.messages.sdkSample}
            icon={faGithub}
        />
    </div>

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <div className="row">
                <div className="d-flex col-lg-6 ">
                    <Card title={intl.messages.csharpCardTitle1} action={cardAction}>
                        <div className="card-text">{intl.messages.csharpCardTxt1}<br /><br /></div>
                    </Card>
                </div> 

                <div className="col-lg-6 d-flex">
                    <Card title={intl.messages.csharpCardTitle2}>
                        <div className="card-text">{intl.messages.csharpCardTxt2}<br/><br/>
                            <div className="row">
                                <div className="col-sm-6">
                                    <ul className="list-unstyled">
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />.NET Core 2.0+</li>
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />.NET Framework 4.6.1+ </li>
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />Unity 2018.1+</li>
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />Mono 5.4+</li>
                                    </ul>
                                </div>

                                <div className="col-sm-6">
                                    <ul className="list-unstyled">
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />Xamarin.iOS 10.14+</li>
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />Xamarin.Android 8.0+</li>
                                        <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />Universal Windows Platform 10.0.16299+</li>
                                    </ul>
                                </div>
                            </div>
                            {intl.formatMessage({id:"csharpCardTxt3"}, { b: chunks => <b>{chunks}</b>})}
                        </div>
                    </Card>
                    {/* <Card extended={true}
                        title="RAINBOW C# SDK"
                        subtitle="[version] - date" 
                        footer="Last updated xxx"
                    >
                        <div className="card-text"><EmptyState icon={faNewspaper} desc="nimia in peiores haeserat plagas" /></div>
                    </Card> */}
                </div>
            </div>

            <div className="row">
                <div className="d-flex col-lg-6 ">
                    <Card title={intl.messages.csharpCardTitle4}>
                        <div className="card-text">{intl.messages.csharpCardTxt4}<br/></div>
                    </Card>
                </div>
            </div>

            <Section 
                title={intl.messages.csharpGlanceTitle} 
                message={intl.messages.csharpGlanceMessage} 
                className="bg-pink"
            />

            <div className="row">
                <SDKCard title={intl.messages.csharpGlanceSubTitle1} icon={faCode}>
                    {intl.messages.csharpGlanceTxt1 + " ( .NET Core 2.0+, .NET Framework 4.6.1+, Mono 5.4+, Xamarin.iOS 10.14+, Xamarin.Android 8.0+, Unity 2018.1+, Universal Windows Platform 10.0.16299+ )"}
                </SDKCard>
                <SDKCard title={intl.messages.csharpGlanceSubTitle2} icon={faUsers}>{intl.messages.csharpGlanceTxt2}</SDKCard>
            </div>

            <div className="row">
                <SDKCard id="messagerie" title={intl.messages.csharpGlanceSubTitle3} icon={faCommentDots}>{intl.messages.csharpGlanceTxt3}</SDKCard>
                <SDKCard id="groupchat" title={intl.messages.csharpGlanceSubTitle6} icon={faComments}>{intl.formatMessage({id:"csharpGlanceTxt6"}, { b: chunks => <b>{chunks}</b>})}</SDKCard>
            </div>

            <div className="row">
                <SDKCard id="calllogs" title={intl.messages.csharpGlanceSubTitle5} icon={faClock}>{intl.messages.csharpGlanceTxt5}</SDKCard>
                <SDKCard id="pstn" title={intl.messages.csharpGlanceSubTitle4} icon={faPhone}>{intl.messages.csharpGlanceTxt4}</SDKCard>
            </div>

            <div className="row">
                <SDKCard id="group" title={intl.messages.csharpGlanceSubTitle7} icon={faUserCircle}>{intl.messages.csharpGlanceTxt7}</SDKCard>
                <SDKCard id="sharing " title={intl.messages.csharpGlanceSubTitle8} icon={faImages}>{intl.messages.csharpGlanceTxt8}</SDKCard>
            </div>

            <div className="row">
                <SDKCard id="channel" title={intl.messages.csharpGlanceSubTitle9} isBeta={true} icon={faPaperPlane}>{intl.messages.csharpGlanceTxt9}</SDKCard>
            </div>
        </div>
    );
}

export default CSharp;